export const faqs = [

  {
    id: "faq-gdg",
    question: "What is a GDG?",
    content: [
      {
        type: "text",
        value:
          "A Google Developer Group (GDG) is a community of developers who meet locally to learn, share, and collaborate on Google technologies and open-source projects."
      }
    ]
  },
  {
    id: "faq-join",
    question: "Who can join a GDG?",
    content: [
      {
        type: "text",
        value:
          "Anyone interested in technology, development, or Google tools can join — students, professionals, and enthusiasts are all welcome."
      }
    ]
  },
  {
    id: "faq-free",
    question: "Are GDG events free?",
    content: [
      {
        type: "text",
        value:
          "Most GDG events are free, though some workshops or conferences may require registration fees depending on the organizer."
      }
    ]
  },
  {
    id: "faq-google-employee",
    question: "Do I need to be a Google employee to participate?",
    content: [
      {
        type: "text",
        value:
          "No. GDGs are community-led. Volunteers organize events and anyone can participate regardless of affiliation."
      }
    ]
  },
  {
    id: "faq-organize",
    question: "Can I organize my own GDG chapter or event?",
    content: [
      {
        type: "text",
        value:
          "Yes! You can apply to become a GDG lead or volunteer to organize events in your area. Check the GDG website for eligibility and requirements."
      }
    ]
  },
  {
    id: "faq-events",
    question: "What kind of events do GDGs organize?",
    content: [
      {
        type: "text",
        value:
          "GDGs organize workshops, hackathons, study jams, tech talks, networking events, and mentorship programs focused on Google technologies."
      }
    ]
  },
  {
    id: "faq-find",
    question: "How do I find a GDG near me?",
    content: [
      {
        type: "text",
        value:
          "Visit the official GDG website, search for your city, and join the community. Most GDGs also have Meetup or Discord channels."
      }
    ]
  },
  {
    id: "faq-focus",
    question: "Do GDGs only focus on coding?",
    content: [
      {
        type: "text",
        value:
          "Not at all. While coding workshops are common, GDGs also offer events on cloud, AI/ML, mobile development, design, and career development."
      }
    ]
  }
];
